export var APP_NAME = "product-app";
export var GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT || "";
export var COTD_WEBSITE_CDN_URL = process.env.NEXT_PUBLIC_COTD_WEBSITE_CDN_URL || "";
export var SOCIAL_URGENCY_WEBSOCKET_URL = process.env.NEXT_PUBLIC_SOCIAL_URGENCY_WEBSOCKET_URL || null;
export var IS_DEV_ENVIRONMENT = false;
export var USE_MOCK = process.env.NEXT_PUBLIC_USE_MOCK === "true";
export var APOLLO_RETRY_TIMEOUT = Number(process.env.NEXT_PUBLIC_APOLLO_RETRY_TIMEOUT) || 8000;
export var RETRIABLE_OPERATIONS = ["BuyBox"];